import DirectionText from "@/components/DirectionText/DirectionText"
import { useStore } from "@/zustand/store"

export default function ShowText() {
  const showText = useStore((state) => state.modalsStates.showText)
  return <DirectionText>{showText}</DirectionText>
}
